import * as Sentry from '@sentry/browser'
import get from 'lodash/get'
import { trackClientEvent } from '../api/mikasa/requests'
import { selectClientId } from '../store/selectors/client'
import { selectAuthedAsClient } from '../store/selectors/auth'
import { BUYER_VIEWED_MARKETS } from '../constants/client/clientEvents'
import { ClientEventNames, ClientEventSources } from '../types/clientEvents'
import { BUYER_DIGEST } from '../constants/client/clientEventSources'

interface TrackBuyerActivityMikasaParams {
  eventName: ClientEventNames
  eventSource: ClientEventSources
  eventProperties?: EventPropertyParams
}

export interface EventPropertyParams {
  activity_source: string
  audience: string
  video_id: string
  video_source: string
}

export const trackBuyerActivityMikasa = (params: TrackBuyerActivityMikasaParams) => async (dispatch, getState) => {
  const state = getState()
  // @ts-ignore
  const clientId = selectClientId(state) as string

  const eventName = get(params, 'eventName')
  const eventSource = get(params, 'eventSource')
  const eventProperties = get(params, 'eventProperties')

  const authedAsCustomer = !selectAuthedAsClient(state)

  if (!clientId || !eventName || authedAsCustomer) {
    return
  }

  try {
    trackClientEvent(eventName, clientId, eventSource, eventProperties)
  } catch (e) {
    Sentry.captureException(e, {
      extra: {
        clientId,
        eventName,
        eventProperties
      }
    })
  }
}

export const trackBuyerViewedMarkets = () => dispatch => {
  dispatch(
    trackBuyerActivityMikasa({
      eventName: BUYER_VIEWED_MARKETS,
      eventSource: BUYER_DIGEST
    })
  )
}

export const getBuyerTrackingEventSubmitted = (key: string): string | null => sessionStorage.getItem(key)

export const setBuyerTrackingEventSubmitted = key => sessionStorage.setItem(key, 'true')

export const trackBuyerEventOnce = (eventName: ClientEventNames, eventSource: ClientEventSources) => dispatch => {
  if (!getBuyerTrackingEventSubmitted(eventName)) {
    dispatch(
      trackBuyerActivityMikasa({
        eventName,
        eventSource
      })
    )
    setBuyerTrackingEventSubmitted(eventName)
  }
}
